<template>
  <div>
    <b-card no-body class="mx-n3 mt-n2">
      <b-row class="mx-1 mt-2 mb-1" align-h="between">
        <h4 class="ml-2">Alert Details</h4>
      </b-row>
      <div v-if="hasdata">
        <b-row class="mx-0 mt-2 mb-1" align-h="between">
          <b-col cols="12" v-if="hasMetadata">
            <XtendAlertsMetaDetails
              :metadata="selectedMetadata"
              :alertType="selectedAlertType"
            ></XtendAlertsMetaDetails>
          </b-col>
          <b-col cols="12">
            <XtendAlertsDetails
              :alertDetails="alertDetails"
            ></XtendAlertsDetails>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import XomesEventBus from '@/xvisor/bus/XomesEventBus';
import XtendAlertsDetails from '@/xvisor/components/xtend/tabs/XtendAlertsDetails.vue';
import XtendAlertsMetaDetails from '@/xvisor/components/xtend/tabs/XtendAlertsMetaDetails.vue';

export default {
  components: {
    XtendAlertsDetails,
    XtendAlertsMetaDetails,
  },
  props: {
    timeRange: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    alertType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loaded: false,
      selectedAlert: null,
      selectedMetadata: {},
      selectedAlertType: '',
      selectedAlertTypeInt: null,
      alertDetails: [],
    };
  },
  computed: {
    hasdata() {
      return this.alertDetails && this.loaded && this.alertDetails.length > 0;
    },
    hasMetadata() {
      return Object.keys(this.selectedMetadata).length > 0;
    },
    xtendAlertsDetailsUrl() {
      const detailEndpoint = '/alertdetail.json';
      const fullUrl = this.url + detailEndpoint;
      return fullUrl;
    },
  },
  methods: {
    httpGet() {
      this.loaded = false;
      this.$http
        .get(this.xtendAlertsDetailsUrl, {
          params: {
            type: this.selectedAlertTypeInt,
            start: this.timeRange.start.toISOString(),
            end: this.timeRange.end.toISOString(),
          },
        })
        .then((response) => {
          const alertData = response.data;
          this.alertDetails = alertData;
        })
        .finally(() => { this.loaded = true; });
    },
  },
  watch: {
    timeRange() {
      this.selectedAlert = null;
    },
  },
  created() {
    XomesEventBus.$on('update-selected-alert', (alert) => {
      this.selectedAlert = alert;
      this.selectedAlertType = alert.type;
      this.selectedAlertTypeInt = alert.typeInt;
      this.selectedMetadata = {};
      this.httpGet();
    });
    XomesEventBus.$on('update-selected-metadata', (selected) => {
      this.selectedMetadata = selected;
    });
  },
};
</script>

<style scoped>
  .header-card {
    width: 100%;
  }
  .header-card>.card-body {
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  }
  .details-row {
    gap: 5rem;
  }
</style>
